import { oneLineTrim } from 'common-tags'
import { environment } from '../config/environment'

const {
    microsoftOfficeRedirectUri: MICROSOFT_OFFICE_REDIRECT_URI,
    microsoftOfficeAuthorizeUrl: MICROSOFT_OFFICE_AUTHORIZE_URL,
} = environment

export const composeOffice365Url = (
    o365ClientId,
    redirectRoute,
    o365UserEmail,
    state
) => oneLineTrim`${MICROSOFT_OFFICE_AUTHORIZE_URL}
        ?client_id=${o365ClientId}
        &response_type=code
        &prompt=login
        &redirect_uri=${encodeURIComponent(
            MICROSOFT_OFFICE_REDIRECT_URI + redirectRoute,
        )}
        &msafed=0
        &resource=${encodeURIComponent('https://graph.microsoft.com')}
        &scope=${encodeURIComponent('openid profile User.ReadWrite')}
        &login_hint=${o365UserEmail}
        &state=${state}
    `

export const linkOffice365Account = (
    o365ClientId,
    o365UserEmail = '',
    redirectRoute = '',
    state
) => {
    const href = composeOffice365Url(o365ClientId, redirectRoute, o365UserEmail, state)
    window.location.href = href
}